// extracted by mini-css-extract-plugin
module.exports = {"htmlEditor":"HtmlEditor_htmlEditor__12ttY","label":"HtmlEditor_label__1oKKc","textEditor":"HtmlEditor_textEditor__1j-49"};